import * as React from "react";
import * as ReactDOM from "react-dom";

interface HelloProps {
  name: string;
}

export class Hello extends React.Component<HelloProps, {}> {
  render() {
    return <div>Hello, {this.props.name}</div>;
  }
}

export const initHello = (domContainer: HTMLDivElement) : void =>{
	ReactDOM.render(
		<Hello name="monkey" />, 
		domContainer);
}
		
export const initHello2 = (domContainer: HTMLDivElement) : void =>{
	ReactDOM.render(
		React.createElement(Hello, { name:"donkey"}), 
		domContainer);
}		
